<template>
  <b-container fluid class="page-stack-detail mx-auto mb-u5">
    <BaseLoadingState v-if="isLoadingPage" ref="baseLoadingState" />
    <b-col v-else class="container-stack-detail p-0" xl="10" lg="12">
      <base-bread-crumb :items="breadcrumbs" class="bg-white" />
      <div class="container-stack-detail__content">
        <StackHeaderInfo
          v-if="stack"
          :stack="stack"
          @login="goToSignInPageWithRedirect()"
          @enroll="scrollToLearningUnitList()"
          @refreshStackData="refreshStackData"
        />
        <div>
          <BaseLoadingState v-if="isRefreshing" />
          <div v-else>
            <StackLearningUnitCardList
              v-if="stack"
              id="StackLearningUnitCardList"
              :learning-units="stack.learning_units"
            />
          </div>
        </div>
      </div>
    </b-col>
  </b-container>
</template>

<script>
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb.vue';
import StackHeaderInfo from './components/StackHeaderInfo.vue';
import StackLearningUnitCardList from './components/StackLearningUnitCardList.vue';
import BaseLoadingState from '@/components/base-components/BaseLoadingState.vue';
import Stack from '@/models/Stack';

export default {
  name: 'PageStackDetailIndex',
  components: {
    BaseBreadCrumb,
    StackHeaderInfo,
    StackLearningUnitCardList,
    BaseLoadingState
  },

  data() {
    return {
      isLoadingPage: false,
      isRefreshing: false,
      stack: null
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          key: 'explore',
          name: 'Explore',
          to: {
            name: 'learning-unit'
          }
        },
        {
          key: 'stack',
          name: this.stack ? this.stack.title : 'Stack',
          active: true
        }
      ];
    }
  },
  mounted() {
    this.initializeStackDetail();
  },
  methods: {
    async getStackDetail(stackId = null) {
      try {
        const result = await Stack.api().findStackDetail(stackId);
        this.stack = result.response.data;
      } catch (error) {
        // If the stack is not found, redirect to the not-found page
        if (error.response.status === 404) {
          this.$router.push({
            name: 'not-found'
          });
        }
        // If there is an error, show a toast message
        else {
          this.$toast.error('Something went wrong');
        }
      }
    },

    goToSignInPageWithRedirect() {
      const previousRoute = this.$router.resolve({
        ...this.$route,
        params: {
          stackId: this.stack.id
        }
      });

      this.$router.push({
        name: 'SignIn',
        query: {
          previousPath: previousRoute.href
        }
      });
    },
    scrollToLearningUnitList() {
      this.$nextTick(() => {
        const element = document.getElementById('StackLearningUnitCardList');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },

    async initializeStackDetail() {
      this.isLoadingPage = true;

      try {
        const stackId = this.$route.params.stackId;
        await this.getStackDetail(stackId);
      } catch (error) {
        console.error('Failed to initialize stack detail:', error);
      } finally {
        this.isLoadingPage = false;
      }
    },

    async refreshStackData(stackId = null) {
      this.isRefreshing = true;

      try {
        await this.getStackDetail(stackId);
      } catch (error) {
        console.error('Failed to refresh stack data:', error);
      } finally {
        this.isRefreshing = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-stack-detail {
  display: flex;
  justify-content: center;
}

.container-stack-detail {
  max-width: 1140px;
}

.container-stack-detail__content {
  display: flex;
  flex-direction: column;
  gap: 60px;
}
</style>
